import React from "react";
import { useTranslation } from "react-i18next";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import StepCard from "../../atoms/StepCard/StepCard.component";
import { IconName } from "../../atoms/Icon/Icon.component";
import { getStepsTranslated } from "../../../constants/steps";
import { newLineText } from "../../../utils/utils";
import {
  StepGrid,
  WorkflowIntro,
  WorkflowSection,
  WorkflowTitle,
  WorkflowWrapper,
} from "./Workflow.styled";

const Workflow = () => {
  const { t } = useTranslation();
  const steps = getStepsTranslated(t);

  return (
    <WorkflowSection id="how-it-works" aria-labelledby="how-title">
      <WorkflowWrapper>
        <WorkflowIntro>
          <div>
            <Eyebrow>{t("landing.workflow.eyebrow")}</Eyebrow>
            <WorkflowTitle id="how-title">
              {newLineText(t("landing.workflow.title")).map((line) => (
                <span key={line}>{line}</span>
              ))}
            </WorkflowTitle>
          </div>
        </WorkflowIntro>
        <StepGrid>
          {steps.map((step) => (
            <StepCard
              key={step.id}
              number={step.number}
              title={step.title}
              description={step.description}
              icon={step.icon as IconName}
              accent={step.accent}
            />
          ))}
        </StepGrid>
      </WorkflowWrapper>
    </WorkflowSection>
  );
};

export default Workflow;
